import Footer from 'Components/Footer';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import Header from 'style-guide/Header';

import CreateNewButton from 'Components/EntityCreateButton';
import Layout from 'Components/Layouts/layout';
import Content from 'Components/Layouts/layout/Content';
import classNames from 'classnames';
import { loadState } from 'configs/localStorage';
import PATHS from 'constants/paths';
import SCREEN_SIZES from 'constants/screen-sizes';
import useWindowSize from 'hooks/useWindowSize';
import { Suspense } from 'react';
import { useSelector } from 'react-redux';
import { getUserData } from 'store/selectors/user';
import PageSpin from 'style-guide/Spin/PageSpin';

const { SIGN_UP, SIGN_IN, FORGOT_PASSWORD, RESET_PASSWORD } = PATHS;
const pathsWithoutHeader = [SIGN_IN, SIGN_UP, FORGOT_PASSWORD, RESET_PASSWORD];

const AppRouterLayout = () => {
  const { entities, role } = useParams();
  const isEntityManagePage = entities && role;
  const { innerWidth } = useWindowSize();
  const { isAuth } = useSelector((state) => state.authorizationsSlice);
  const user = useSelector(getUserData);

  const { pathname } = useLocation();
  const isSettingsPage = pathname.includes('manage');
  const isHeaderFooterHidden =
    pathsWithoutHeader?.includes(pathname) || pathsWithoutHeader?.includes(pathname.slice(0, -1));

  const { adminUser } = loadState();
  const isAdminViewingOtherProfile = adminUser && user.userName !== adminUser.userName;

  const showCreateButton = SCREEN_SIZES.XL <= innerWidth && isAuth && !isEntityManagePage && !isSettingsPage;

  if (
    isAuth &&
    user &&
    !user.isPasswordChanged &&
    pathname !== PATHS.FORCE_CHANGE_PASSWORD &&
    !isAdminViewingOtherProfile
  ) {
    return <Navigate to={PATHS.FORCE_CHANGE_PASSWORD} replace />;
  }

  return (
    <Layout className={classNames({ 'admin-page': pathname.startsWith('/admin/') || isHeaderFooterHidden })}>
      {!isHeaderFooterHidden && <Header />}
      <Content>
        <Suspense fallback={<PageSpin />}>
          <Outlet />
        </Suspense>
        {showCreateButton ? <CreateNewButton /> : null}
      </Content>
      {!isHeaderFooterHidden && <Footer />}
    </Layout>
  );
};

export default AppRouterLayout;
